// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"1c8bfc9e","243":"181dc8e5","409":"1584ea74","620":"18b09ddf","723":"827a863c","734":"f6f53b93","786":"6e5fb69c"}[chunkId] + ".chunk.css";
};